Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "MembersCount2712293246",
  {"root":"MembersCount2712293246--root"},
  "",
  1,
  "MembersCount2712293246"
);

